var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { createGlobalStyle } from 'styled-components';
import LinearProgress from '@material-ui/core/LinearProgress';
var ClassStyle = createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .MuiLinearProgress-root {\n    position: fixed;\n    width: 100%;\n    z-index: 2000;\n  }\n\n  .MuiLinearProgress-colorPrimary {\n    background-color: ", ";\n  }\n\n  .MuiLinearProgress-barColorPrimary {\n    background-color: ", ";\n  }\n"], ["\n  .MuiLinearProgress-root {\n    position: fixed;\n    width: 100%;\n    z-index: 2000;\n  }\n\n  .MuiLinearProgress-colorPrimary {\n    background-color: ", ";\n  }\n\n  .MuiLinearProgress-barColorPrimary {\n    background-color: ", ";\n  }\n"])), function (props) { return props.theme.palette.extend1; }, function (props) { return props.theme.palette.primary; });
var LoadingProgress = function (_a) {
    var _b = _a.isLoading, isLoading = _b === void 0 ? true : _b;
    var _c = useState(false), isShow = _c[0], setIsShow = _c[1];
    useEffect(function () {
        var timer;
        if (isLoading)
            setIsShow(true);
        else
            timer = setTimeout(function () { return setIsShow(false); }, 200);
        return function () { return clearTimeout(timer); };
    }, [isLoading]);
    return (_jsxs(_Fragment, { children: [isShow && _jsx(LinearProgress, {}), _jsx(ClassStyle, {})] }));
};
export default LoadingProgress;
var templateObject_1;
